function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.0089 7.74124H15.7526C15.4794 7.74124 15.2196 7.87249 15.0588 8.09749L10.8481 13.9368L8.94099 11.2903C8.78028 11.068 8.52314 10.9341 8.24724 10.9341H6.99099C6.81688 10.9341 6.7151 11.1323 6.81688 11.2743L10.1544 15.9028C10.2332 16.0129 10.3372 16.1026 10.4576 16.1644C10.578 16.2263 10.7114 16.2585 10.8468 16.2585C10.9822 16.2585 11.1156 16.2263 11.236 16.1644C11.3564 16.1026 11.4604 16.0129 11.5392 15.9028L17.1803 8.08142C17.2847 7.93946 17.183 7.74124 17.0089 7.74124Z",
  fill: "#008E04"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.00100708C5.37321 0.00100708 0 5.37422 0 12.001C0 18.6278 5.37321 24.001 12 24.001C18.6268 24.001 24 18.6278 24 12.001C24 5.37422 18.6268 0.00100708 12 0.00100708ZM12 21.9653C6.49821 21.9653 2.03571 17.5028 2.03571 12.001C2.03571 6.49922 6.49821 2.03672 12 2.03672C17.5018 2.03672 21.9643 6.49922 21.9643 12.001C21.9643 17.5028 17.5018 21.9653 12 21.9653Z",
  fill: "#008E04"
});

const SvgSuccessIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success-icon.96388732.svg";
export { ForwardRef as ReactComponent };